import { css } from 'styled-components';

export const titleStyles = css`
  font-family: 'OpenSans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: var(--river-bed);
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default { titleStyles };
